export const RAIL_SLOT_VARIABLE = '--hop-rail-slot'

export const RAIL_SLOT_SIZE = `var(${RAIL_SLOT_VARIABLE}, 1.6875rem)`

export const RAIL_ICON_SIZE = 19.2

export const RAIL_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)'

export const RAIL_SPRING = 'cubic-bezier(0.34, 1.56, 0.64, 1)'

export const RAIL_MOTION = `320ms ${RAIL_EASE}`

export const railIconHover = {
  ':not(:hover) svg': { transition: `transform 200ms ${RAIL_EASE}` },
  ':hover svg': { transform: 'translateY(-1px) scale(1.2)', transition: `transform 320ms ${RAIL_SPRING}` },
  '@media (prefers-reduced-motion: reduce)': { ':hover svg': { transform: 'none' } },
} as const

export const MENU_RAIL_WIDTH = '3.5rem'

export const MENU_OPEN_WIDTH_VARIABLE = '--hop-menu-open-width'

export const MENU_MOTION = '260ms cubic-bezier(0.4, 0, 0.2, 1)'

const RAIL_STAGGER_VARIABLE = '--hop-rail-stagger'

export const railStagger = (rows: number, stepMs: number) =>
  Object.fromEntries(
    Array.from({ length: rows }, (_, index) => [
      `:nth-child(${index + 1})`,
      { [RAIL_STAGGER_VARIABLE]: `${index * stepMs}ms` },
    ]),
  )

export const railStaggerDelay = (baseMs: number) => `calc(${baseMs}ms + var(${RAIL_STAGGER_VARIABLE}, 0ms))`

export const railContentFadeIn = {
  animationDuration: '280ms',
  animationDelay: railStaggerDelay(90),
  animationTimingFunction: RAIL_EASE,
  animationFillMode: 'both',
  '@media (prefers-reduced-motion: reduce)': { animationName: 'none' },
} as const

export const railSlideIn = {
  from: { opacity: 0, transform: 'translateX(-0.375rem)' },
  to: { opacity: 1, transform: 'none' },
}

export const RAIL_BUTTON_WIDTH = '2.5rem'

export const RAIL_BUTTON_INSET = `calc((${RAIL_BUTTON_WIDTH} - ${RAIL_ICON_SIZE}px) / 2)`

export const railIconPop = {
  from: { opacity: 0, transform: 'scale(0.6)' },
  to: { opacity: 1, transform: 'none' },
}

// Above the left menu (z-index 1000) and the cut offers banner (1100), like the banner's own tooltips.
export const RAIL_OVERLAY_Z_INDEX = 1200

export const RAIL_OVERLAY_OFFSET_PX = 8
